import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { Acf } from '../../../../../wp_types'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { markdown } from '../../../utils/markdown'
import { CustomBlockData } from '../types.mod'

export type BSLHeaderBlockProps = {
  block_index?: number
  title: string
  description?: Acf.Wysiwyg
}

export type BSLHeaderBlockStyle = Partial<{}>

export function BSLHeaderBlock<customBlockData, extra_images>(
  props: BSLHeaderBlockProps,
  options?: { style?: BSLHeaderBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <>
          <section className="block block--bsl-header" key={options && options.key ? options.key : 'text-block'}>
            <div className="block__inner">
              <h1 className="header__title title--l" dangerouslySetInnerHTML={{ __html: markdown(props.title) }} />
            </div>
          </section>
        </>
      )
    })
}
